import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Box, Stack } from "@common/components/";
import { Progress } from '@curves/ui-shared';

/** 進行中／未達 100%：primary 紫色 */
const COLOR_PRIMARY = "#653AC2";
/** 驗收完成（100%）：成功狀態綠色 */
const COLOR_SUCCESS = "#2e7d32";
/** 驗收失敗：錯誤狀態紅色 */
const COLOR_ERROR = "#f44336";

/** status 對應顏色，傳入 "primary" | "success" */
const STATUS_COLOR_MAP = {
	primary: COLOR_PRIMARY,
	success: COLOR_SUCCESS,
	error: COLOR_ERROR,
};

/**
 * 驗收進度：由分子/分母換算百分比，顯示百分比文字 + 分數 + 進度條
 * @param {number} numerator 分子（已驗收數量）
 * @param {number} denominator 分母（總數量）
 * @param {"primary"|"success"} status primary=進行中(紫)，success=完成(綠)
 */
const InspectionProgress = ({ numerator = 0, denominator = 0, status = "primary", className, style }) => {
	const percent = denominator === 0 ? 0 : (numerator / denominator) * 100;
	const normalizedPercent = Math.max(0, Math.min(100, percent));
	const progressColor = status ? STATUS_COLOR_MAP[status] : undefined;

	return (
		<Box className={clsx("inspection-progress", className)} style={style}>
			<Stack justifyContent="space-between" alignItems="end" className="inspection-progress-header">
				<Box className="inspection-progress-percent">{`${Math.round(normalizedPercent)}%`}</Box>
				<Box className="inspection-progress-fraction">{`${numerator}/${denominator}`}</Box>
			</Stack>
			<Progress value={normalizedPercent} getColor={() => progressColor}>
				<Progress.Track>
					<Progress.Indicator />
				</Progress.Track>
			</Progress>
		</Box>
	);
};

InspectionProgress.propTypes = {
	numerator: PropTypes.number,
	denominator: PropTypes.number,
	status: PropTypes.string,
	className: PropTypes.string,
};

export default InspectionProgress;
